
import MinusSquare from "../../../assets/outline/MinusSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MinusSquareIcon({ className, dataTestid = "MinusSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MinusSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
